import { render } from "./TimestampManager.vue?vue&type=template&id=1d1209f0&scoped=true"
import script from "./TimestampManager.vue?vue&type=script&lang=js"
export * from "./TimestampManager.vue?vue&type=script&lang=js"

import "./TimestampManager.vue?vue&type=style&index=0&id=1d1209f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1209f0"]])

export default __exports__